/**
 * Decode a base64url-encoded string.
 *
 * Base64url (used by JWTs per RFC 7515 §2) differs from standard base64 in two
 * ways: `+` and `/` are replaced with `-` and `_`, and trailing `=` padding is
 * stripped. `atob` expects standard base64 with padding, so we swap the
 * alphabet back and re-pad before decoding.
 */
export function decodeBase64Url(input: string): string {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);

  return atob(padded);
}
